<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="report px-2">
    <!-- Basic info -->
    <table class="table table-sm">
      <tbody>
        <tr>
          <td colspan="2">
            <span class="span-header">{{ $t('menu.work_report') }}</span>
          </td>
        </tr>
        <tr>
          <td class="item-detail-title">
            {{ $t('work_report.customer') }}
          </td>
          <td class="item-detail-text">
            {{ reportDetails.order.contract.customer.name }}
          </td>
        </tr>
        <tr>
          <td class="item-detail-title">
            {{ $t('work_report.contract') }}
          </td>
          <td class="item-detail-text">
            {{ reportDetails.order.contract.name }}
          </td>
        </tr>
        <tr>
          <td class="item-detail-title">
            {{ $t('work_report.task_type') }}
          </td>
          <td class="item-detail-text">
            {{ reportDetails.order.task_type.name }}
          </td>
        </tr>
        <tr>
          <td class="item-detail-title">
            {{ $t('work_report.start_time') }}
          </td>
          <td class="item-detail-text">
            {{ toLocalTime(reportDetails.start_time) }}
          </td>
        </tr>
        <tr>
          <td class="item-detail-title">
            {{ $t('work_report.end_time') }}
          </td>
          <td class="item-detail-text">
            {{ toLocalTime(reportDetails.end_time) }}
          </td>
        </tr>
        <tr>
          <td class="item-detail-title">
            {{ $t('work_report.reporter') }}
          </td>
          <td
            v-if="reportDetails.reporter"
            class="item-detail-text"
          >
            {{ reportDetails.reporter.first_name + ' ' + reportDetails.reporter.last_name }}
          </td>
        </tr>
        <tr>
          <td class="item-detail-title">
            {{ $t('work_report.info') }}
          </td>
          <td class="item-detail-text">
            {{ reportDetails.info }}
          </td>
        </tr>
      </tbody>
    </table>

    <!--Work team-->
    <span v-if="reportDetails.persons && reportDetails.persons.length" class="span-header mt-2">
      {{ $t('work_report.work_team') }}
    </span>
    <div
      v-if="reportDetails.persons && reportDetails.persons.length"
      id="persons"
      class="col-sm-12 panel-group data-container"
    >
        <vue3-datatable
            ref="resultTable"
            :rows="reportDetails.persons"
            :columns="teamFields"
            :pagination="false"
            :sticky-header="true"
            height="100%"
            :sortable="true"
            skin="bh-table-compact"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
        >
            <template #certificates="row">
                <div>
                    {{ row.value && row.value.certificates ? getCertificates(row.value.certificates) : '' }}
                </div>
            </template>
        </vue3-datatable>
    </div>

    <!--Trip logs-->
    <span v-if="tripLogs && tripLogs.length" class="span-header mt-2">
      {{ $t('work_report.trips') }}
    </span>
    <div
      v-if="tripLogs && tripLogs.length"
      id="tripLogs"
      class="col-sm-12 panel-group data-container"
    >
        <vue3-datatable
            ref="resultTable"
            :rows="tripLogs"
            :columns="tripLogFields"
            :pagination="false"
            :sticky-header="true"
            height="100%"
            :sortable="true"
            skin="bh-table-compact"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
        >
            <template #vehicle="row">
                <div>
                    {{ row.value && row.value.vehicle ? row.value.vehicle : '' }}
                </div>
            </template>
            <template #start_time="row">
                <div>
                    {{ row.value && row.value.start_time ? toLocalTime(row.value.start_time) : '' }}
                </div>
            </template>
            <template #end_time="row">
                <div>
                    {{ row.value && row.value.end_time ? toLocalTime(row.value.end_time) : '' }}
                </div>
            </template>
            <template #mode="row">
                <div>
                    {{ row.value && row.value.mode ? getTripModeString(row.value.mode) : '' }}
                </div>
            </template>
        </vue3-datatable>
    </div>

    <!--Materials-->
    <span v-if="reportDetails.material_reports && reportDetails.material_reports.length" class="span-header mt-2">
      {{ $t('work_report.materials') }}
    </span>
    <div
      v-if="reportDetails.material_reports && reportDetails.material_reports.length"
      id="materials"
      class="col-sm-12 panel-group data-container"
    >
        <vue3-datatable
            ref="resultTable"
            :rows="reportDetails.material_reports"
            :columns="materialFields"
            :pagination="false"
            :sticky-header="true"
            height="100%"
            :sortable="true"
            skin="bh-table-compact"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
        />
    </div>

    <!--Consignment notes-->
    <span v-if="reportDetails.consignment_notes && reportDetails.consignment_notes.length" class="span-header mt-2">
      {{ $t('work_report.consignment_notes') }}
    </span>
    <div
      v-if="reportDetails.consignment_notes && reportDetails.consignment_notes.length"
      id="consignmentNotes"
      class="col-sm-12 panel-group data-container"
    >
        <vue3-datatable
            ref="resultTable"
            :rows="reportDetails.consignment_notes"
            :columns="consignmentNotesFields"
            :pagination="false"
            :sticky-header="true"
            height="100%"
            :sortable="true"
            skin="bh-table-compact"
            row-class="routa-table-row"
            cell-class="routa-table-cell"
        >
            <template #time="row">
                <div>
                    {{ row.value.time ? toLocalTime(row.value.time) : '' }}
                </div>
            </template>
            <template #vehicle="row">
                <div>
                    {{ row.value.vehicle ? getVehicleString(row.value.vehicle) : '' }}
                </div>
            </template>
            <template #photo="row">
                <font-awesome-icon
                    icon="paperclip"
                    class="attachment-icon"
                    @click.stop="downloadNoteAttachment(row.value.photo)"
                    style="width: 1em; height: auto"
                />
            </template>
        </vue3-datatable>
    </div>

    <!--Recipes-->
    <span
      v-if="reportDetails.recipes && reportDetails.recipes.length > 0"
      class="span-header"
    >
      {{ $t('work_report.attachments') }}
    </span>
    <div
      v-for="recipe in reportDetails.recipes"
      :key="recipe.id"
    >
      <div>
        <font-awesome-icon
          icon="paperclip"
          class="attachment-icon"
          @click.stop="downloadRecipe(recipe)"
        />
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {timeUtils} from '../mixins/TimeUtils'
import {printHelper} from '../mixins/PrintMixin'
import {restApi} from '../mixins/RestApiMixin'
import {Printd} from 'printd'
import {vehicleHelper} from '../mixins/VehicleMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'WorkReportDetails',
    components: {Vue3Datatable},
    mixins: [timeUtils, printHelper, restApi, vehicleHelper],
    props: {
        reportDetails: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            attachment: null,
            sortDesc: false,
            loading: false,
            teamSortBy: 'last_name',
            materialSortBy: 'road_num',
            consignmentNotesSortBy: 'road_num',
            tripLogSortBy: 'vehicle',
            tripLogs: []
        }
    },
    computed: {
        teamFields() {
            return [
                {field: 'first_name', title: this.$t('work_report.first_name'), sort: false, headerClass: 'routa-table-header'},
                {field: 'last_name', title: this.$t('work_report.last_name'), sort: false, headerClass: 'routa-table-header'},
                {field: 'tax_number', title: this.$t('users.tax_number'), sort: false, headerClass: 'routa-table-header'},
                {field: 'certificates', title: this.$t('menu.certificates'), sort: false, headerClass: 'routa-table-header'}
            ]
        },
        materialFields() {
            return [
                {field: 'road_num', title: this.$t('work_report.road_no'), sort: false, headerClass: 'routa-table-header'},
                {field: 'start_sec_num', title: this.$t('work_report.road_section_from'), sort: false, headerClass: 'routa-table-header'},
                {field: 'end_sec_num', title: this.$t('work_report.road_section_to'), sort: false, headerClass: 'routa-table-header'},
                {field: 'location_info', title: this.$t('work_report.location_info'), sort: false, headerClass: 'routa-table-header'},
                {field: 'amount', title: this.$t('work_report.amount'), sort: false, headerClass: 'routa-table-header'},
                {field: 'unit', title: this.$t('work_report.unit'), sort: false, headerClass: 'routa-table-header'}
            ]
        },
        consignmentNotesFields() {
            return [
                {field: 'note_number', title: this.$t('work_report.booking_no'), sort: false, headerClass: 'routa-table-header'},
                {field: 'time', title: this.$t('work_report.time'), sort: false, headerClass: 'routa-table-header'},
                {field: 'station', title: this.$t('work_report.station'), sort: false, headerClass: 'routa-table-header'},
                {field: 'vehicle', title: this.$t('work_report.vehicle'), sort: false, headerClass: 'routa-table-header'},
                {field: 'amount', title: this.$t('work_report.amount'), sort: false, headerClass: 'routa-table-header'},
                {field: 'photo', title: this.$t('work_report.attachment'), sort: false, headerClass: 'routa-table-header'}
            ]
        },
        tripLogFields() {
            return [
                {field: 'vehicle', title: this.$t('work_report.vehicle'), sort: false, headerClass: 'routa-table-header'},
                {field: 'mode', title: this.$t('work_report.mode'), sort: false, headerClass: 'routa-table-header'},
                {field: 'start_time', title: this.$t('work_report.start'), sort: false, headerClass: 'routa-table-header'},
                {field: 'end_time', title: this.$t('work_report.end'), sort: false, headerClass: 'routa-table-header'},
                {field: 'length', title: this.$t('work_report.distance'), sort: false, headerClass: 'routa-table-header'}
            ]
        }
    },
    mounted() {
        this.d = new Printd()
        this.getTripLogs()
    },
    methods: {
        getCertificates: function (certificates) {
            var string = ''
            certificates.forEach(function (certificate) {
                if (string.length !== 0) {
                    string += ', '
                }
                string += certificate.type.name
                if (certificate.expiration_day) {
                    string += ' - '
                    string += this.getShortDateString(certificate.expiration_day)
                }
            }, this)
            return string
        },
        print() {
            if (!this.loading) {
                this.d.print(this.$el, this.printStyle)
            }
        },
        downloadNoteAttachment: function (photo) {
            let consignmentNote = this.reportDetails.consignment_notes.find(function (note) {
                return note.photo.id === photo.id
            }, this)
            if (consignmentNote) {
                this.download(this.consignmentNoteUrl + consignmentNote.id + '/' + photo.id, photo)
            }
        },
        downloadRecipe: function (recipe) {
            this.download(this.recipeUrl + recipe.id + '/' + recipe.photo.id, recipe.photo)
        },
        download: function (url, photo) {
            if (!this.loading) {
                this.loading = true
                this.attachment = photo
                this.restFetch(url, this.handleResponse)
            }
        },
        handleResponse: function (response) {
            this.loading = false
            if (response && response.status === 200) {
                this.saveFile(response.data)
            }
        },
        saveFile: function (base64Image) {
            let a = document.createElement('a')
            document.body.appendChild(a)
            a.style = 'display: none'
            a.href = base64Image
            if (this.attachment.file_type === 'image/png') {
                a.download = this.attachment.id + '.png'
            } else {
                a.download = this.attachment.id + '.jpeg'
            }
            a.click()
        },
        getTripLogs: function () {
            this.loading = true
            this.restFetch(this.workReportsTripLogUrl + '/' + this.reportDetails.id, this.handleTripLogResponse)
        },
        handleTripLogResponse: function (response) {
            this.tripLogs = response.data
            this.loading = false
        },
        getVehicleString: function (vehicle) {
            let result = '-'
            if (vehicle && vehicle.make) {
                result = vehicle.make
                if (vehicle.vehicle_model) {
                    result += ' ' + vehicle.vehicle_model
                }
                if (vehicle.license_plate) {
                    result += ' (' + vehicle.license_plate + ')'
                }
            }
            return result
        }
    }
}
</script>
